import type { AlertDto } from "../../types/AlertDto";
import type { AlertEntity } from "../../types/AlertEntity";

export const AlertDtoToEntity = ({ ...rest }: Readonly<AlertDto>): AlertEntity => {
    return { ...rest };
};
